<template>
  <div class="col-date" :style="styleProperty">
    {{
      resolveDate(columnProperties.value, resolveFormatDate) == "Invalid Date"
        ? "-"
        : resolveDate(columnProperties.value, resolveFormatDate)
    }}
  </div>
</template>

<script>
import { dateColumn } from "@/configs/dynamic-config/dynamic-column";
import { computed } from "@vue/composition-api";
import useDate from "@/utils/hooks/useDate";
export default {
  props: {
    columnProperties: Object,
  },
  setup(props) {
    const { resolveDate } = useDate();

    const styleProperty = computed(() => {
      return {};
    });

    const resolveFormatDate = computed(() => {
      return (
        props.columnProperties.field.column_property.date_format || dateColumn.date_format
      );
    });

    return {
      styleProperty,
      resolveFormatDate,
      resolveDate,
    };
  },
};
</script>

<style scoped>
.col-date {
  color: #737373;
  display: inline-block;
}
</style>
